import {Fragment, PureComponent} from 'react'
import PropTypes from 'prop-types'
import ParagraphLeftAlign from "../../../../../shared/components/Styled/ParagraphLeftAlign.jsx"
import PrimaryButton from "../../../../../shared/components/Styled/Buttons/PrimaryButton.jsx"
import SecondaryButton from "../../../../../shared/components/Styled/Buttons/SecondaryButton.jsx"
import {Col, Row} from "reactstrap"
import { parseISO, isAfter } from 'date-fns'

import {
  CREATE_FREELANCE_STEPS,
  updateCreatFreelanceStep
} from "../../../../../shared/containers/Freelance/setNextStep.js"

import connectModal from "../../../../../shared/components/Modals/connect.js"
import MissionModal from "../../../../components/Modals/Mission/MissionModal.jsx"
import DeleteMissionModal from "../../../../components/Modals/Mission/DeleteMissionModal.jsx"
import DeleteAllMissionsModal from "../../../../components/Modals/Mission/DeleteAllMissionsModal.jsx"
import PrimaryOutlineButton from "../../../../../shared/components/Styled/Buttons/PrimaryOutlineButton.jsx"
import {calculateTotalExperience} from "../../../../../shared/services/freelanceService.js"
import Missions from "./Missions.jsx"
import MissionExampleModal from "../Modals/MissionExampleModal.jsx"
import {isArray} from "validate.js"
import {toastr} from "react-redux-toastr"
import H5TitleLeftAlign from "../../../../../shared/components/Styled/H5TitleLeftAlign.jsx"

import {
  purchaseExample
} from "./MissionTemplates/purchaseExample.js"
import {
  humanResourceExample
} from "./MissionTemplates/humanResourceExample.js"
import {
  financeExample
} from "./MissionTemplates/financeExample.js"
import {
  engineeringExample
} from "./MissionTemplates/engineeringExample.js"

const universeExample = [
  {
    code: 'purchase',
    template: purchaseExample,
    job: 'Acheteur crayons',
    company: 'MAPED',
    period: '01/2022 - 08/2022',
  }, {
    code: 'finance',
    template: financeExample,
    job: 'Responsable du contrôle des coûts',
    company: 'Société X',
    period: 'de mars 2021 à décembre 2021',
  },
  {
    code: 'hr',
    template: humanResourceExample,
    job: 'Responsable RH site',
    company: 'Société X',
    period: 'de mars 2021 à décembre 2021',
  },
  {
    code: 'engineering',
    template: engineeringExample,
    job: 'Ingénieur chef de projets',
    company: 'Société X',
    period: 'de mars 2021 à décembre 2021',
  },
]

class ProfessionalXp extends PureComponent {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    freelance: PropTypes.object.isRequired,
    submit: PropTypes.func.isRequired,
    prevPage: PropTypes.func.isRequired
  }

  constructor(props) {
    super(props)

    this.state = {
      isMissionModalOpen: false,
      experiences: props.freelance?.experiences?.length ? props.freelance.experiences : [],
      universeExample: universeExample[0]
    }
  }

  componentDidMount() {
    this.setUniverseState()
  }

  componentDidUpdate(prevProps, prevState, prevContext) {
    this.setUniverseState()
  }

  getSortedMissions = (experiences) => {
    return [...experiences]
      .sort((a, b) => {
        if (a.current && !b.current) {
          return -1
        }

        if (b.current && !a.current) {
          return 1
        }

        const dateA = parseISO(a.start)
        const dateB = parseISO(b.start)
        if (dateA && dateB) {
          if (isAfter(dateA, dateB)) {
            return -1
          } else {
            return 1
          }
        } else {
          return 0
        }
      })
  }

  setUniverseState = () => {
    if (!this.props || !this.props.currentUniverse || !this.props.currentUniverse.code) {
      return
    }

    const universeCode = this.props.currentUniverse.code
    const found = universeExample.find((universe) => universe.code === universeCode)

    if (!found) {return}
    this.setState({universeExample: found})
  }

  goToStep = (step) => {
    updateCreatFreelanceStep(
      this.props.freelance.id,
      step,
      () => this.props.submit({
        freelance: {
          ...this.props.freelance
        },
        silentMode: true,
      })
    )
  }

  createNewMission = () => {
    this.props.openMissionModal({
      freelance: this.props.freelance,
      experiences: this.state.experiences?.length ? this.state.experiences : [],
      onClose: this.onClose,
      onSubmit: this.props.submit,
    })
  }

  openMissionExampleModal= () => {
    this.setState({isMissionModalOpen: true})
  }
  closeMissionExampleModal= () => {
    this.setState({isMissionModalOpen: false})
  }

  onSubmitMissions = () => {
    const missions = this.state.experiences?.length ? this.state.experiences : []
    if(missions && isArray(missions) && missions.length > 0){
      this.goToStep(CREATE_FREELANCE_STEPS.VALIDATION)
      return
    }
    toastr.error('Veuillez renseigner vos expériences professionnelles afin de finaliser votre profil.')
  }

  onClose = (newExperiences) => {
    const clonedExperiences = newExperiences.map(exp => ({ ...exp }))
    this.props.freelance.experiences = newExperiences
    this.setState({ experiences: this.getSortedMissions(clonedExperiences) })
  }

  render() {
    return (
      <Fragment>
        <H5TitleLeftAlign title="Expériences professionnelles"/>
        <Row>
          <Col className={'txt-left  mt-2 col-12 col-sm-auto'}>
            <PrimaryOutlineButton className="ml-auto ml-sm-0 mr-auto" onClick={this.createNewMission}>
              Ajouter une expérience +
            </PrimaryOutlineButton>
          </Col>
          <Col className={'text-left  mt-2 col-12 col-sm-auto'}>
            <SecondaryButton onClick={this.openMissionExampleModal}>Voir un exemple de mission</SecondaryButton>
          </Col>
        </Row>

        <Row className={"mt-4"}>
          <Col> <strong>Expérience : {calculateTotalExperience(this.state.experiences)?.label} </strong></Col>
        </Row>

        {!this.state.experiences.length ?
          <ParagraphLeftAlign>
            Aucune expérience renseignée pour le moment.
            Cliquez sur le bouton "Ajouter une expérience" ci-dessus pour démarrer.
          </ParagraphLeftAlign>
          : <Fragment>
            <Missions
              className="callout callout-mission"
              freelance={this.props.freelance}
              experiences={this.state.experiences}
              submit={this.props.submit}
              onClose={this.onClose}
              canEdit={true}
            />
          </Fragment>
        }

        <Row className={"mt-4 justify-space-between"}>
          <Col className={'text-center'}>
            <SecondaryButton className="ml-auto ml-sm-0 mr-auto mt-2" onClick={this.props.prevPage}> Retourner aux
              instructions </SecondaryButton>
          </Col>
          <Col className={"text-center"}>
            <PrimaryButton className="ml-auto mr-auto mr-sm-0 mt-2" onClick={this.onSubmitMissions}>
              J'ai rempli toutes mes missions
            </PrimaryButton>
          </Col>
        </Row>

        {this.state.universeExample &&
        <MissionExampleModal
          currentUniverseExample={this.state.universeExample}
          isOpen={this.state.isMissionModalOpen}
          closeModal={this.closeMissionExampleModal}/>}

      </Fragment>
    )
  }
}

export default connectModal({MissionModal, DeleteMissionModal, DeleteAllMissionsModal}, ProfessionalXp)
